import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { apiPost } from '../../../lib/api.js';
import { useAuthStore } from '../../../store/authStore.js';
import { DeletionPendingBanner } from './DeletionPendingBanner.js';

export function AppDeletionBanner() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const syncWithBackend = useAuthStore((s) => s.syncWithBackend);
  const [canceling, setCanceling] = useState(false);

  if (!user?.deletionScheduledAt) return null;

  const handleCancel = async () => {
    setCanceling(true);
    try {
      await apiPost('/users/me/cancel-deletion');
      useAuthStore.setState({
        user: { ...user, deletionScheduledAt: null, deletionRequestedFrom: null },
      });
      void syncWithBackend();
      toast.success(t('settings.privacy.deletion.cancelSuccess'));
    } catch {
      toast.error(t('settings.privacy.deletion.cancelError'));
    } finally {
      setCanceling(false);
    }
  };

  return (
    <DeletionPendingBanner
      compact
      scheduledAt={user.deletionScheduledAt}
      canceling={canceling}
      onCancel={() => void handleCancel()}
    />
  );
}
